// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "GOUDA A. Chabilou",
  description:
    "Je m'appelle GOUDA ARZOUMA Chabilou, je suis développeur Full-Stack passionné basé a Cotonou, Bénin. Avec une solide expérience en développement web et mobile, je crée des solutions logicielles qui allient performance et intuitivité.",
  og: {
    title: "GOUDA A. Chabilou Portfolio",
    type: "website",
    url: "#/",
  },
};

//Hero Page
const greeting = {
  title: "GOUDA A. Chabilou",
  logo_name: "Blooz-dev",
  nickname: "Blooz Dev",
  subTitle:
    "Je m'appelle GOUDA ARZOUMA Chabilou, je suis développeur Full-Stack passionné basé a Cotonou, Bénin. Avec une solide expérience en développement web et mobile, je crée des solutions logicielles qui allient performance et intuitivité.",
  resumeLink:
    "https://drive.google.com/file/d/18Z8HXIwIlpC_BrmmLdXkXViR_vIHlosR/view?usp=sharing",
  portfolio_repository: "https://github.com/Blooz231",
  githubProfile: "https://github.com/Blooz231",
};

const serviceHead = {
  title: "Services",
  logo_name: "Blooz-dev",
  subTitle:
    "Découvrez mes services et laissez-moi transformer vos besoins en solutions concrètes et innovantes.",
};

// Lien Socials
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Blooz231",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/chabilou-g-073949209/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "YouTube",
    link: "https://youtube.com/@chabilougouda7773",
    fontAwesomeIcon: "fa-youtube",
    backgroundColor: "#FF0000",
  },
  {
    name: "Gmail",
    link: "mailto:goudachabilou@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "X-Twitter",
    link: "https://x.com/Bloozangus",
    fontAwesomeIcon: "fa-x-twitter",
    backgroundColor: "#000000",
  },
  // {
  //   name: "Facebook",
  //   link: "https://www.facebook.com",
  //   fontAwesomeIcon: "fa-facebook-f",
  //   backgroundColor: "#1877F2",
  // },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/layman_brother/",
  //   fontAwesomeIcon: "fa-instagram",
  //   backgroundColor: "#E4405F",
  // },
];

const skills = {
  data: [
    // {
    //   title: "Data Science & AI",
    //   fileName: "DataScienceImg",
    //   skills: [
    //     "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
    //     "⚡ Experience of working with Computer Vision and NLP projects",
    //     "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Tensorflow",
    //       fontAwesomeClassname: "logos-tensorflow",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Keras",
    //       fontAwesomeClassname: "simple-icons:keras",
    //       style: {
    //         backgroundColor: "white",
    //         color: "#D00000",
    //       },
    //     },
    //     {
    //       skillName: "PyTorch",
    //       fontAwesomeClassname: "logos-pytorch",
    //       style: {
    //         backgroundColor: "transparent",
    //       },
    //     },
    //     {
    //       skillName: "Python",
    //       fontAwesomeClassname: "ion-logo-python",
    //       style: {
    //         backgroundColor: "transparent",
    //         color: "#3776AB",
    //       },
    //     },
    //     {
    //       skillName: "Deeplearning",
    //       imageSrc: "deeplearning_ai_logo.png",
    //     },
    //   ],
    // },
    {
      title: "Développeur Full Stack,",
      fileName: "FullStackImg",
      skills: [
        "⚡ Développement d'interfaces web réactives avec Vue.js",
        "⚡ Création d'applications mobiles avec Flutter, React Native",
        "⚡ Développement de backends avec PHP (Laravel), Node.js (Express) et Python (Flask)",
        "⚡ Conception et gestion de bases de données SQL (MySQL, PostgreSQL) et NoSQL (MongoDB)",
        "⚡ Développement de bots de trading avec MQL5",
        "⚡ Sécurisation des applications (protection contre XSS, CSRF, injection SQL)",
        "⚡ Optimisation des performances et gestion des API RESTful",
        "⚡ Déploiement et hébergement avec Apache, Nginx",
        "⚡ Gestion des dépendances avec Yarn, Npm et Composer",
      ],
      softwareSkills: [
        // {
        //   skillName: "HTML5",
        //   fontAwesomeClassname: "simple-icons:html5",
        //   style: {
        //     color: "#E34F26",
        //   },
        // },
        {
          skillName: "Tailwind",
          fontAwesomeClassname: "simple-icons:tailwind",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Laravel",
          fontAwesomeClassname: "simple-icons:laravel",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Maîtrise de divers services cloud pour le déploiement et la gestion d’infrastructures",
        "⚡ Configuration et gestion de serveurs virtuels avec connexion aux bases de données",
        "⚡ Implémentation et optimisation de modèles d’intelligence artificielle sur le cloud pour une accessibilité mobile",
        "⚡ Automatisation des échanges de données entre serveurs et bases de données sur GCP et AWS",
      ],
      softwareSkills: [
        // {
        //   skillName: "Google Cloud",
        //   fontAwesomeClassname: "simple-icons:googlecloud",
        //   style: {
        //     color: "#4285F4",
        //   },
        // },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        // {
        //   skillName: "Azure",
        //   fontAwesomeClassname: "simple-icons:microsoftazure",
        //   style: {
        //     color: "#0089D6",
        //   },
        // },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "simple-icons:vercel",
          style: {
            color: "#000",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Conception d'interfaces utilisateur modernes et attrayantes pour applications web et mobiles avec Figma",
        "⚡ Création et personnalisation de logos uniques à partir de zéro",
        "⚡ Élaboration de parcours utilisateurs intuitifs pour une expérience optimisée",
      ],
      softwareSkills: [
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/layman_brother/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Indian Institute of Information Technology Kurnool",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "http://iiitk.ac.in",
    },
    {
      title: "Indiana University Bloomington",
      subtitle: "M.S. in Computer Science",
      logo_path: "iu_logo.png",
      alt_name: "Indiana University Bloomington",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
        "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
        "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
      ],
      website_link: "https://www.indiana.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Expérience",
  subtitle: "PROFIL PROFESSIONNEL",
  description:
    "Développeur Full-Stack avec plus de 4 ans d’expérience dans la conception et" +
    "le développement d’applications web et mobiles robustes, ainsi que dans la création" +
    "de solutions IoT innovantes.Spécialisé en PHP, JavaScript, Vue.js, React et Laravel," +
    "avec une expertise en intégration de systèmes embarqués via Arduino.Passionné par " +
    "l’analyse de données et la gestion de projets techniques de bout en bout, avec une " +
    "solide expérience en Backend et en systèmes de gestion.",

  header_image_path: "experience.svg",
  sections: [
    {
      title: "Travail",
      work: true,
      experiences: [
        {
          title: "Développeur Web & Mobile | Technicien Réseau",
          company: "Système et Orbite",
          company_url: "https://www.systeme-orbite.com/",
          logo_path: "deeplearning_ai_logo.png",
          duration: "Juin 2022 - Décembre 2022",
          location: "Bénin",
          description:
            "Développement et maintenance d’applications web et mobiles en utilisant Vue.js, React et Laravel. Optimisation des infrastructures réseau pour garantir une meilleure connectivité et sécurité des systèmes d’information.",
          color: "#000000",
        },
        {
          title: "Développeur Full-Stack, Mobile & IoT",
          company: "ArimaxeTechnologie",
          company_url: "https://www.arimaxetechnologie.com/",
          logo_path: "arimaxe_logo.png",
          duration: "Décembre 2022 - Décembre 2024",
          location: "Bénin",
          description:
            "Développement de solutions web et mobiles avec Laravel, Node.js et React. Intégration de solutions IoT basées sur Arduino pour l'automatisation et la collecte de données en temps réel. Participation à l’architecture et la gestion des bases de données MySQL et MongoDB.",
          color: "#F39C12",
        },
        {
          title: "Développeur Web & Mobile",
          company: "Freelance",
          company_url: "#",
          logo_path: "deeplearning_ai_logo.png",
          duration: "2020 - 2023",
          location: "Bénin, Cotonou",
          description:
            "Développement d’applications web et mobiles pour des clients internationaux, avec un focus sur les systèmes de gestion et les ERP.",
          color: "#9b1578",
        },
        {
          title: "Versionisation & GitHub ",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "2022 - PRESENT",
          location: "",
          description:
            "Expérimenté dans la gestion de versions de projets avec Git, et utilisation de GitHub pour faciliter la collaboration et le suivi des versions.",
          color: "#181717",
        },
        // {
        //   title: "Android Developer",
        //   company: "FreeCopy Pvt. Ltd.",
        //   company_url: "https://www.linkedin.com/company/freecopy/about/",
        //   logo_path: "freecopy_logo.png",
        //   duration: "Nov 2017 - Dec 2017",
        //   location: "Ahmedabad, Gujarat",
        //   description:
        //     "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
        //   color: "#fc1f20",
        // },
      ],
    },
    {
      title: "Stages",
      experiences: [
        {
          title: "Stage en Développement Web",
          company: "Etrilab Parakou",
          company_url: "https://etrilabs.com/",
          logo_path: "deeplearning_ai_logo.png",
          duration: "Mars 2021 - Août 2021",
          location: "Parakou, Bénin",
          description:
            "Conception et personnalisation de sites web sous WordPress. Développement de modules spécifiques et amélioration de l’expérience utilisateur à travers des optimisations UI/UX.",
          color: "#3498DB",
        },
        // {
        //   title: "Data Science Research Intern",
        //   company: "Delhivery Pvt. Ltd.",
        //   company_url: "https://www.delhivery.com/",
        //   logo_path: "delhivery_logo.png",
        //   duration: "May 2019 - Sept 2019",
        //   location: "Gurgaon, Haryana",
        //   description:
        //     "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
        //   color: "#ee3c26",
        // },
        // {
        //   title: "Data Science Intern",
        //   company: "Intel Indexer LLC",
        //   company_url:
        //     "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
        //   logo_path: "intel_logo.jpg",
        //   duration: "Nov 2018 - Dec 2018",
        //   location: "Work From Home",
        //   description:
        //     "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
        //   color: "#0071C5",
        // },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        // {
        //   title: "Google Explore ML Facilitator",
        //   company: "Google",
        //   company_url: "https://about.google/",
        //   logo_path: "google_logo.png",
        //   duration: "June 2019 - April 2020",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
        //   color: "#4285F4",
        // },
        // {
        //   title: "Microsoft Student Partner",
        //   company: "Microsoft",
        //   company_url: "https://www.microsoft.com/",
        //   logo_path: "microsoft_logo.png",
        //   duration: "Aug 2019 - May 2020",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
        //   color: "#D83B01",
        // },
        // {
        //   title: "Mozilla Campus Captain",
        //   company: "Mozilla",
        //   company_url: "https://www.mozilla.org/",
        //   logo_path: "mozilla_logo.png",
        //   duration: "Oct 2019 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
        //   color: "#000000",
        // },
        // {
        //   title: "Developer Students Club Member",
        //   company: "DSC IIITDM Kurnool",
        //   company_url:
        //     "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
        //   logo_path: "dsc_logo.png",
        //   duration: "Jan 2018 - May 2020",
        //   location: "Kurnool, Andhra Pradesh",
        //   description:
        //     "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
        //   color: "#0C9D58",
        // },
        // {
        //   title: "Versionisation & GitHub ",
        //   company: "Github",
        //   company_url: "https://github.com/",
        //   logo_path: "github_logo.png",
        //   duration: "2022 - PRESENT",
        //   location: "",
        //   description:
        //     "Expérimenté dans la gestion de versions de projets avec Git, et utilisation de GitHub pour faciliter la collaboration et le suivi des versions.",
        //   color: "#181717",
        // },
      ],
    },
  ],
};

// A propos
const aboutsListe = {
  title: "À propos de moi",
  subtitle: "Biographie",
  description:
    "Passionné par le développement de solutions technologiques innovantes, j'ai eu l'opportunité de collaborer avec diverses entreprises et de maîtriser plusieurs domaines techniques.",
  description2:
    "En 2022, j'ai rejoint Système et Orbite en tant que développeur web et application mobile, ainsi que technicien en réseau. En décembre de la même année, j'ai intégré ArimaxeTechnologie en qualité de développeur web et mobile, ainsi que développeur IoT, où j'ai pu renforcer mes compétences techniques et contribuer efficacement à divers projets.",
  description3:
    "Auparavant, en 2021, j'ai effectué un stage professionnel de six mois chez Etrilab Parakou durant ma période scolaire. Cette expérience m'a permis d'approfondir mes connaissances et de les appliquer dans des contextes réels, enrichissant ainsi mon profil professionnel.",
  description4:
    "En dehors de mon travail, je suis très investi dans l'innovation technologique et je reste constamment informé des dernières avancées dans le domaine. Ma passion pour la programmation et la technologie est également alimentée par mes intérêts personnels tels que la lecture, l'écoute de musique, suivre les actualités technologiques, et regarder des mangas. Mon objectif est de continuer à évoluer dans ce secteur dynamique et de proposer des solutions créatives et impactantes.",
  header_image_path: "experience.svg",
};

// Projects Page
const projectsHeader = {
  title: "Mes réalisations",
  subTitle: "Découvrez mes projtes récente",
  description:
    "J'ai développé plusieurs applications web et mobiles, conçu des systèmes IoT innovants, et contribué à des projets open-source, mettant en avant mon expertise en développement Full-Stack et en intelligence artificielle.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "J'ai rédigé et partagé plusieurs articles et projets sur le développement web, l'IoT et l'intelligence artificielle, contribuant ainsi à la diffusion des connaissances et à l'enrichissement de la communauté tech..",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "bientôt",
      name: "Arrive Bientôt",
      createdAt: "0000:00:00 à 00:00:00Z",
      description: "En cours de développement",
      url: "#",
    },
    // {
    //   id: "mdp-diffusion",
    //   name: "MDP-Diffusion",
    //   createdAt: "2023-09-19T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/mdp-diffusion/",
    // },
    // {
    //   id: "consistency-models",
    //   name: "Consistency Models",
    //   createdAt: "2023-10-12T00:00:00Z",
    //   description: "Blog published in Paperspace",
    //   url: "https://blog.paperspace.com/consistency-models/",
    // },
  ],
};

// Liste des Service orfaite
const services = {
  data: [
    {
      id: "Dev-web",
      name: "Développement Web Front-End",
      description:
        "Je conçois et développe des sites web performants, modernes et adaptés aux besoins spécifiques de mes clients. Grâce à une expertise approfondie en frontend et backend, je m'assure que chaque projet est bien structuré et optimisé pour offrir une expérience utilisateur fluide.",
      spacialité: ["React.js", "Vue.js", "TailwindCSS", "Bootstrap"],
      icon: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Vue",
          iconifyClass: "logos-vue",
        },
        {
          name: "Tailwind",
          iconifyClass: "catppuccin:tailwind",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
        {
          name: "Html",
          iconifyClass: "proicons:html",
        },
        {
          name: "CSS",
          iconifyClass: "catppuccin:css",
        },
        {
          name: "JS",
          iconifyClass: "vscode-icons:file-type-js-official",
        },
      ],
    },
    {
      id: "Dev-mobile",
      name: "Développement Mobile",
      description:
        "Je développe des applications mobiles performantes et réactives adaptées aux plateformes Android et iOS. Avec un focus sur les technologies modernes et optimisées pour l'expérience utilisateur.",
      spacialité: ["Flutter", "React Native", "Swift", "Kotlin"],
      icon: [
        {
          name: "Flutter",
          iconifyClass: "logos-flutter",
        },
        {
          name: "React Js/Native",
          iconifyClass: "logos-react",
        },
        {
          name: "Android",
          iconifyClass: "basil:android-outline",
        },
        {
          name: "iOS",
          iconifyClass: "lineicons:ios",
        },
      ],
    },
    {
      id: "Dev-back",
      name: "Développement Backend",
      description:
        "Je maîtrise le développement backend pour des applications robustes et scalables. Avec des compétences en PHP (Laravel, Php Natif) et Node.js, je fournis des solutions optimisées pour la performance et la sécurité.",
      spacialité: ["Node.js", "Express.js", "Laravel", "Django"],
      icon: [
        {
          name: "Node.js",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Express.js",
          iconifyClass: "simple-icons:expressdotcom",
        },
        {
          name: "Laravel",
          iconifyClass: "logos-laravel",
        },
        {
          name: "Django",
          iconifyClass: "logos-django",
        },
        {
          name: "API",
          iconifyClass: "hugeicons:api",
        },
      ],
    },
    {
      id: "Dev-api",
      name: "Développement d'API",
      description:
        "Je conçois et développe des APIs RESTful et GraphQL robustes et sécurisées. Grâce à des compétences en Node.js et PHP (Laravel), je fournis des services fiables et performants.",
      spacialité: ["REST API", "GraphQL", "Swagger", "Postman"],
      icon: [
        {
          name: "REST API",
          iconifyClass: "logos-rest-api",
        },
        {
          name: "GraphQL",
          iconifyClass: "logos-graphql",
        },
        {
          name: "Swagger",
          iconifyClass: "logos-swagger",
        },
        {
          name: "Postman",
          iconifyClass: "cib:postman",
        },
      ],
    },
    {
      id: "reseau",
      name: "Administration Réseau",
      description:
        "Mise en place et gestion des infrastructures réseaux pour assurer la connectivité et la sécurité des systèmes informatiques.",
      spacialité: ["Cisco", "MikroTik", "VPN", "Sécurité Réseau"],
      icon: [
        {
          name: "Cisco",
          iconifyClass: "cib:cisco",
        },
        {
          name: "VPN",
          iconifyClass: "material-symbols:vpn-lock",
        },
        {
          name: "Firewall",
          iconifyClass: "iconoir:pc-firewall",
        },
        {
          name: "Cloud Networking",
          iconifyClass: "fluent:cloud-sync-28-regular",
        },
      ],
    },
    {
      id: "maintenance-informatique",
      name: "Maintenance Informatique",
      description:
        "Diagnostic, dépannage et optimisation des systèmes informatiques pour garantir leur bon fonctionnement.",
      spacialité: [
        "Support Technique",
        "Réparation Matériel",
        "Optimisation Logicielle",
        "Gestion de Parc Informatique",
      ],
      icon: [
        {
          name: "Support Technique",
          iconifyClass: "flat-color-icons:support",
        },
        {
          name: "Réparation",
          iconifyClass: "fluent-mdl2:data-management-settings",
        },
        {
          name: "Optimisation Logicielle",
          iconifyClass: "eos-icons:software-outlined",
        },
        {
          name: "Gestion Informatique",
          iconifyClass: "carbon:cloud-service-management",
        },
        {
          name: "Helpdesk",
          iconifyClass: "arcticons:servicedesk-plus-saas-helpdesk",
        },
      ],
    },
    {
      id: "consulting-it",
      name: "Consulting IT",
      description:
        "Conseils stratégiques et accompagnement pour aider les entreprises à adopter les meilleures solutions technologiques.",
      spacialité: [
        "Transformation Digitale",
        "Cloud Computing",
        "Gestion de Projet IT",
        "Audit Informatique",
      ],
      icon: [
        {
          name: "Consulting",
          iconifyClass: "carbon:ibm-consulting-advantage-agent",
        },
        {
          name: "Gestion de Projet",
          iconifyClass: "ix:project-configuration",
        },
        {
          name: "Audit Informatique",
          iconifyClass: "ant-design:audit-outlined",
        },
        {
          name: "Stratégie IT",
          iconifyClass: "material-symbols-light:strategy-outline",
        },
      ],
    },
    {
      id: "cybersecurite",
      name: "Cybersécurité",
      description:
        "Protection des données et des systèmes contre les cyberattaques à travers des solutions de sécurité avancées.",
      spacialité: [
        "Sécurité Applicative",
        "Pentest",
        "SOC",
        "Protection des Données",
      ],
      icon: [
        {
          name: "Sécurité",
          iconifyClass: "arcticons:security",
        },
        {
          name: "Protection des Données",
          iconifyClass: "mdi:cloud-security-outline",
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Obtenez de l'assistance ",
    profile_image_path: "blooz_angus.png",
    description:
      "Je suis présent sur presque tous les réseaux sociaux. Vous pouvez m’envoyer un message, et je répondrai sous 24 heures. Je peux vous aider en développement Full-Stack, IoT, intelligence artificielle, cloud et open source.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Je partage mes connaissances et expériences sur mon blog, où je publie des articles sur le développement Full-Stack, l’IoT, l’intelligence artificielle et les nouvelles technologies.",
    link: "#",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Cotonou / Bénin",
    locality: "Cotonou",
    country: "Bénin",
    region: "Litoral",
    postalCode: "229",
    streetAddress: "Calavie",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl",
  },
  phoneSection: {
    title: "+2290169413757",
    subtitle: "+2290195173458",
  },
};

const contactInfo = {};
const openSource = {};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  services,
  aboutsListe,
  contactInfo,
  openSource,
  serviceHead,
};
